import { useState } from "react";
import { clock, dur, useTick } from "../lib/time";
import { ClientChip } from "./bits";
import { hueOf } from "../lib/api";
import { hue, hrs } from "../lib/time";
import { EstLabel } from "./EstimatePicker";

const PARKED = ["waiting_client", "waiting_internal", "on_hold", "not_given"];
const STATE = { waiting_client: "With client", waiting_internal: "With team", on_hold: "On hold", not_given: "Not given", done: "Done", paused: "Paused", todo: "To start" };
const pocText = (ids, pmap) => { const n = (ids || []).map((x) => pmap[x]).filter(Boolean); return !n.length ? "No POC" : n.length > 1 ? `${n[0]} +${n.length - 1}` : n[0]; };

function Live({ since, base = 0 }) {
  const t = useTick(1000);
  return <b className="mono live-t">{clock(base + t - since)}</b>;
}

export function FloorCard({ t, names, pmap = {}, draggable, onOpen, onDropBefore, from, dim }) {
  const [over, setOver] = useState(false);
  const drag = draggable ? {
    draggable: true,
    onDragStart: (e) => e.dataTransfer.setData("text/plain", JSON.stringify({ id: t.id, from })),
  } : {};
  const dropHere = onDropBefore ? {
    onDragOver: (e) => { e.preventDefault(); e.stopPropagation(); setOver(true); },
    onDragLeave: () => setOver(false),
    onDrop: (e) => { e.preventDefault(); e.stopPropagation(); setOver(false); onDropBefore(JSON.parse(e.dataTransfer.getData("text/plain"))); },
  } : {};
  const live = !!t.runningSince;
  const parked = PARKED.includes(t.state) || t.kind === "standby";
  const noEst = t.estimateLabel === "No estimate";
  const state = live ? "▶ Live" : t.state === "done" ? "✓ Done" : t.kind === "standby" && !PARKED.includes(t.state) ? "If any" : t.loggedMs > 0 && !PARKED.includes(t.state) ? "❚❚ Paused" : STATE[t.state] || "To start";
  const cls = ["fcard", live && "live", t.state === "done" && "done", over && "over", dim && "dim", parked && !live && "hatch", t.kind === "standby" && !live && "standby", t.unplanned && !live && "unpl", draggable && "drag"].filter(Boolean).join(" ");
  return (
    <button className={cls} onClick={onOpen} {...drag} {...dropHere} data-testid={`floor-card-${t.id}`}
      aria-label={`${names[t.client] || t.client}: ${t.title}, ${t.estimateLabel}, ${state.replace(/^[^A-Za-z]+/, "")}`}>
      <span className="fc-bar" style={{ background: `oklch(0.62 0.15 ${hueOf(t.client) ?? hue(t.client)})` }} aria-hidden="true" />
      <div className="fc-top"><ClientChip code={t.client} name={names[t.client]} /><span className="fc-cn">{names[t.client] || t.client}</span>
        {t.moreTime?.status === "added" ? <span className="fc-more">+{hrs(t.moreTime.hours)}</span>
          : <span className={`fc-kind ${t.kind === "revision" ? "rev" : ""}`}>{t.kind === "revision" ? "Rev" : t.kind === "adapt" ? "Adapt" : t.kind === "standby" ? "" : "New"}</span>}</div>
      <div className="fc-title">{t.title}</div>
      <div className="fc-poc"><span aria-hidden="true">↳</span><span className="trunc">{pocText(t.pocs, pmap)}</span>{EstLabel({ t }) || <b className={`num ${noEst ? "noest" : ""}`}>{noEst ? "No est" : t.estimateLabel}</b>}</div>
      <div className="fc-state"><span>{state}{t.autoStopped && <span className="auto" data-testid={`autostopped-${t.id}`}> · Auto-stopped</span>}</span>
        {live ? <Live since={t.runningSince} base={t.todayClosedMs || 0} /> : <span className="num">{dur(t.loggedMs || 0)}</span>}</div>
    </button>
  );
}
